const IS_BROWSER = typeof window !== `undefined`

const DOMAINS = {
  default: '.decathlon.com.br',
  dktLab: '.dktlab.com.br',
  vtexApp: '.vtex.app',
}

type CookieOptions = {
  expiresInMinutes?: number
  domain?: string
  path?: string
  sameSite?: 'Lax' | 'Strict' | 'None'
  secure?: boolean
}

export const getCookie = (cname: string): string | undefined => {
  if (!IS_BROWSER || !document.cookie) {
    return
  }

  const encodedName = `${encodeURIComponent(cname)}=`

  const cookies = document.cookie.split(';')

  for (const cookie of cookies) {
    const trimmed = cookie.trim()

    if (trimmed.startsWith(encodedName)) {
      const rawValue = trimmed.slice(encodedName.length)

      try {
        return decodeURIComponent(rawValue)
      } catch {
        return rawValue
      }
    }
  }
}

export function deleteCookie(name: string): void {
  if (!IS_BROWSER || !document.cookie) {
    return
  }

  const encodedName = encodeURIComponent(name)
  const expires = 'expires=Thu, 01 Jan 1970 00:00:00 GMT'

  document.cookie = `${encodedName}=; ${expires}; path=/`
}

export const readCookie = (cookie: string): boolean => {
  if (!IS_BROWSER) {
    return false
  }

  return document.cookie.split('; ').includes(cookie)
}

export const setCookie = (
  name: string,
  value: string,
  options: CookieOptions = {}
): void => {
  if (typeof document === 'undefined') {
    return
  }

  const {
    expiresInMinutes,
    domain = getDomain(),
    path = '/',
    sameSite = 'Lax',
    secure = window.location.protocol === 'https:',
  } = options

  const encodedName = encodeURIComponent(name)
  const encodedValue = encodeURIComponent(value)

  const parts = [`${encodedName}=${encodedValue}`, `path=${path}`]

  if (expiresInMinutes !== undefined) {
    const date = new Date(Date.now() + expiresInMinutes * 60 * 1000)

    parts.push(`expires=${date.toUTCString()}`)
  }

  if (domain) parts.push(`domain=${domain}`)
  if (sameSite) parts.push(`SameSite=${sameSite}`)
  if (secure) parts.push('Secure')

  document.cookie = parts.join(';')
}

export const calculateExpirationDate = (lifetimeInSeconds: number) => {
  const currentDate = new Date()
  const expirationDate = new Date(
    currentDate.getTime() + lifetimeInSeconds * 1000
  )

  return expirationDate.toUTCString()
}

export function getDomain(url?: string) {
  if (!IS_BROWSER) {
    return DOMAINS.default
  }

  const testingUrl = url ?? window?.location?.host

  if (testingUrl?.includes('decathlon.com')) {
    return DOMAINS.default
  }

  if (
    testingUrl?.includes('vtex.app') ||
    testingUrl?.includes('decathlonstore')
  ) {
    return DOMAINS.vtexApp
  }

  if (testingUrl.includes('dktlab.com.br')) {
    return DOMAINS.dktLab
  }

  return null
}
